import { createSlice } from "@reduxjs/toolkit";
import { getLookupMargins, saveLookupMargins } from "../../Thunk/LookupMargin/MarginThunk";

const initialState = {
    lookupMargins: {},
    error: null,
    cancel: false,
};

const lookupMarginSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch lookup
      .addCase(getLookupMargins.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(getLookupMargins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.lookupMargins = action.payload;
        state.error = "";
      })
      .addCase(getLookupMargins.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // fetch lookup
      .addCase(saveLookupMargins.pending, (state) => {
        state.error = "";
      })
      .addCase(saveLookupMargins.fulfilled, (state, action) => {
        state.error = "";
      })
      .addCase(saveLookupMargins.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default lookupMarginSlice.reducer;
